// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"448c4d2f","977":"608e27f2"}[chunkId] + ".chunk.js";
};